import React from "react";
import { T } from "services/lang/LanguageService";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { TaskTemplateInputFromSubgroup } from "../../../../../api/model/airflow-task/task-template/TaskTemplateInfo";

const renderIdInput = (
  rowData: TaskTemplateInputFromSubgroup,
  options: any,
  updateSubFormId: (index: number, value: string) => void
) => {
  if (rowData.inputs && rowData.inputs[options.rowIndex]) {
    return (
      <InputText
        placeholder="id"
        value={rowData.inputs[options.rowIndex].id}
        onChange={e => updateSubFormId(options.rowIndex, e.target.value)}
        className="p-inputtext-sm"
      />
    );
  }
  return null;
};

const renderTitleInput = (
  rowData: TaskTemplateInputFromSubgroup,
  options: any,
  updateSubFormTitle: (index: number, value: string) => void
) => {
  if (rowData.inputs && rowData.inputs[options.rowIndex]) {
    return (
      <InputText
        placeholder={T("word.title")}
        value={rowData.inputs[options.rowIndex].title}
        onChange={e => updateSubFormTitle(options.rowIndex, e.target.value)}
        className="p-inputtext-sm"
      />
    );
  }
  return null;
};

const renderHeaderInput = (
  rowData: TaskTemplateInputFromSubgroup,
  options: any,
  updateSubFormHeader: (index: number, value: string) => void
) => (
  <InputText
    placeholder={T("word.header")}
    value={rowData.header ?? ""}
    onChange={e => updateSubFormHeader(options.rowIndex, e.target.value)}
    className="p-inputtext-sm"
  />
);

const renderDeleteButton = (
  confirmOnDelete: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>, index: number) => void
) => {
  const DeleteButton = (_: any, options: any) => (
    <Button
      icon="pi pi-trash"
      className="p-button-sm p-button-danger p-button-text"
      onClick={e => confirmOnDelete(e, options.rowIndex)}
    />
  );

  DeleteButton.displayName = "DeleteButton";

  return DeleteButton;
};

const handleMiniDialogCancel = (
  setMiniDialog: React.Dispatch<React.SetStateAction<boolean>>,
  setNewId: React.Dispatch<React.SetStateAction<string>>,
  setNewTitle: React.Dispatch<React.SetStateAction<string>>
) => {
  setMiniDialog(false);
  setNewId("");
  setNewTitle("");
};

const createObject = (setMiniDialog: React.Dispatch<React.SetStateAction<boolean>>) => {
  setMiniDialog(true);
};

export {
  renderHeaderInput,
  renderDeleteButton,
  renderIdInput,
  renderTitleInput,
  handleMiniDialogCancel,
  createObject,
};
